module.exports = __webpack_public_path__ + "img/Refresh.2a48ea0d.svg";